export const navigateToRelativePath = (path: string | URL) => {
  if (!path) {
    return null;
  }

  return window.location.assign(path.toString());
};

export const openUrlOnNewTab = (url: string | URL) => {
  if (!url) {
    return null;
  }

  return window.open(url.toString(), '_blank');
};
